// 일렉트론 메인 앱의 전역 Vue.mixin을 분리 환경에 맞게 옮긴 것.
// 모든 컴포넌트에 this.user / this.hospital 등을 주입한다.
// (일렉트론은 main.js에서 Vue.mixin으로 전역 주입했고, 예약 컴포넌트들이 이 멤버에 의존함)
//
// 일렉트론 원본 mixin의 data 멤버 중 예약 트리가 실제로 쓰는 것만 추렸다.
// (ChatController/MPAWS/fnCommon/commonConfig/Dashboard_API/AL_API는 예약이 안 써서 제외)
// V2_API·V3_API 는 vue-query 훅(src/composables/queries)으로 전면 대체되어 제거됨.
import { mapState, mapActions } from 'vuex';
import ToastController from '@/controller/ToastController';
import AlertController from '@/controller/AlertController';
import i18n from '@/locale/i18n';

export default {
  data() {
    return {
      ToastController,
      AlertController,
    };
  },
  computed: {
    ...mapState(['user', 'hospital', 'servicesetting', 'remote_notification', 'chatroom', 'badge', 'SaaS']),
    hospitalLocale() {
      return this?.SaaS?.locale || 'ko-KR';
    },
  },
  watch: {
    // 병원 로케일이 바뀌면 i18n 언어도 따라가도록 (일렉트론 원본과 동일)
    hospitalLocale: {
      immediate: false,
      handler(newValue, oldValue) {
        if (newValue === oldValue) return;
        i18n.locale = newValue;
      },
    },
  },
  methods: {
    ...mapActions(['AC_ServiceSetting', 'setPopup', 'setToast', 'AC_SetSelectedChatRoom', 'AC_SetBadge', 'AC_UpdatePushNotificationValue']),
  },
};
